// extracted by mini-css-extract-plugin
module.exports =  {"description":"vObmL2n12w06Sfad0x_t","path":"Qgh_VtR9FmdcujVXB0PB","single":"ofHLEY3WwWRiX37gpHRI"};